import { useEffect, useState } from "react";
import { AnimatePresence, motion, useReducedMotion } from "framer-motion";
import { CheckIcon } from "lucide-react";
import type { VerifiedPurchase } from "../data/recentPurchases";
type RecentPurchaseToastProps = {
  purchases: VerifiedPurchase[];
  hidden?: boolean;
};
export function RecentPurchaseToast({
  purchases,
  hidden = false
}: RecentPurchaseToastProps) {
  const [activeIndex, setActiveIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(true);
  const prefersReducedMotion = useReducedMotion();
  useEffect(() => {
    if (purchases.length < 2) return;
    const rotation = window.setInterval(() => {
      setIsVisible(false);
      window.setTimeout(() => {
        setActiveIndex(currentIndex => (currentIndex + 1) % purchases.length);
        setIsVisible(true);
      }, 400);
    }, 5400);
    return () => window.clearInterval(rotation);
  }, [purchases.length]);
  if (purchases.length === 0 || hidden) return null;
  const purchase = purchases[activeIndex];
  return <div className="pointer-events-none fixed inset-x-4 bottom-24 z-40 mx-auto max-w-[360px] md:inset-x-auto md:bottom-5 md:left-5" aria-live="polite" data-id="element-311" data-mp="2d8yt0r32tnf9">
    <AnimatePresence mode="wait" data-id="element-312" data-mp="2mztj66jg175z">
      {isVisible && <motion.aside key={`${purchase.buyerName}-${purchase.purchaseTime}`} initial={prefersReducedMotion ? {
        opacity: 1
      } : {
        opacity: 0,
        y: 15
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={prefersReducedMotion ? {
        opacity: 1
      } : {
        opacity: 0,
        y: 8
      }} transition={{
        duration: prefersReducedMotion ? 0 : 0.4,
        ease: [0.22, 1, 0.36, 1]
      }} className="border border-[#cfb37e] bg-[#fffaf0] px-4 py-3 shadow-[0_10px_24px_rgba(61,38,63,0.16)]" data-id="element-313" data-mp="2mzjqucaxenx4">
        <div className="flex gap-3" data-id="element-314" data-mp="2478u706v7m7g"><motion.span initial={prefersReducedMotion ? false : {
            scale: 0.94,
            boxShadow: "0 0 0 0 rgba(178,210,105,0.42)"
          }} animate={prefersReducedMotion ? undefined : {
            scale: [0.94, 1.08, 1],
            boxShadow: ["0 0 0 0 rgba(178,210,105,0.42)", "0 0 0 7px rgba(178,210,105,0)", "0 0 0 3px rgba(178,210,105,0.13)"]
          }} transition={{
            duration: prefersReducedMotion ? 0 : 0.55,
            ease: [0.22, 1, 0.36, 1]
          }} className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-[#dcebb1] text-[#31562d] shadow-[0_0_0_3px_rgba(178,210,105,0.13)]" data-id="element-315" data-mp="1z9z7vtervqnu"><CheckIcon size={14} strokeWidth={2.5} data-id="element-316" data-mp="3rrkza8i10hvm" /></motion.span><div className="min-w-0" data-id="element-317" data-mp="kgt1ftpgzo9"><p className="text-sm leading-5 text-[#543655]" data-id="element-318" data-mp="jp8d01ncmcr"><strong className="font-semibold" data-id="element-319" data-mp="ie5r3jxtkn8">{purchase.buyerName}</strong> adquirió el <span className="font-semibold text-[#432545]" data-id="element-320" data-mp="2z3xiz5nsgdes">{purchase.productName}</span></p><p className="mt-1 text-xs text-[#796875]" data-id="element-321" data-mp="342iit3z4ov2p">{purchase.location} <span className="mx-1 text-[#ad813c]" data-id="element-322" data-mp="390jz5h566gah">·</span> {purchase.purchaseTime}</p></div></div>
      </motion.aside>}
    </AnimatePresence>
  </div>;
}